import React, { useEffect } from 'react';
import Offers from 'modules/Offers';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import OfferPromoBanner from 'components/OfferPromoBanner';

interface RegistrationOfferPromoBannerProps {
  affiliateId?: string;
  promoCode?: string;
}

const RegistrationOfferPromoBanner = ({
  affiliateId,
  promoCode
}: RegistrationOfferPromoBannerProps) => {
  const dispatch = useAppDispatch();
  const offers = useAppSelector((state) => Offers.selectors.getOffersByName(state, 'registration'));

  useEffect(() => {
    void Offers.actions.registrationOffer({
      promoCode,
      // The promoCode has a higher priority than the affiliateId
      affiliateId: promoCode ? '' : affiliateId
    })(dispatch);
  }, [dispatch, affiliateId, promoCode]);

  if (!offers || offers.length < 1) {
    return null;
  }

  return <OfferPromoBanner offer={offers[0]} />;
};

export default RegistrationOfferPromoBanner;
